import { CAFirmUsers, Prisma, User } from '@commenda/prisma';
import { TGetCompanyMembersResponse } from '@commenda/types/src/company/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TAccountantMarketplaceService } from './types';

export type UseCAFirmMembersOptions = {
  disableRevalidation: boolean;
  includeMarketplaceServices?: boolean;
  includeCustomerMarketplaceServices?: boolean;
};

export type CAFirmUser = CAFirmUsers & {
  user: User;
};

export type CAFirmWithUsers = Prisma.CAFirmGetPayload<{
  include: {
    corporationHasCAFirm: {
      include: {
        corporation: true;
      };
    };
  };
}> & {
  users: CAFirmUser[];
  accountingFirmMarketplaceService?: TAccountantMarketplaceService[];
};

export function useCAFirmMembers(
  token: string,
  caFirmId: string,
  options?: UseCAFirmMembersOptions
) {
  const swrOptions = options?.disableRevalidation
    ? {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      }
    : {};

  const query = new URLSearchParams();
  if (options?.includeMarketplaceServices) {
    query.append('includeMarketplaceServices', 'true');
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: TGetCompanyMembersResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `caFirm/${caFirmId}/members?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    ),
    swrOptions
  );

  return {
    data,
    error,
    mutate,
  };
}
